import { connect, ConnectedProps } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { RootState } from '../../../../store/root-reducer';
import {
  signupRequest,
  hideSignupRequestError,
  getAnonymousUserHashRequest,
} from '../signup/signup-slice';
import { acceptInvitationRequest } from '../invitation-signup/invitation-signup-slice';
import { AcceptInvitationRequestPayload } from '../../types/request-payload';
import SignupForm from './signup-form';

const mapStateToProps = (state: RootState) => ({
  signupRequestStatus: state.signup.signupRequest.status,
  signupRequestMessage: state.signup.signupRequest.message,
  signupRequestError: state.signup.signupRequest.error,
  showError: state.signup.signupRequest.showError,
  trackingId: state.invitationSignup.trackingId,
  firstName: state.invitationSignup.firstName,
  lastName: state.invitationSignup.lastName,
  acceptInvitationRequestStatus:
    state.invitationSignup.acceptInvitationRequest.status,
  anonymousUserHashStatus: state.signup.anonymousUserHashStatus,
  anonymousUserHash: state.signup.anonymousUserHash,
  anonymousUserId: state.signup.anonymousUserId,
});

const mapDispatchToProps = {
  hideError: () => hideSignupRequestError(),
  sendSignupRequest: (
    email: string,
    landingPage: string,
    timeZone: string,
    rewardfulReferralId: string,
    captchaToken: string,
  ) =>
    signupRequest({
      email,
      landingPage,
      timeZone,
      rewardfulReferralId,
      captchaToken,
    }),
  sendAcceptInvitationRequest: (payload: AcceptInvitationRequestPayload) =>
    acceptInvitationRequest(payload),
  sendGetAnonymousUserHashRequest: () => getAnonymousUserHashRequest(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> &
  RouteComponentProps & {
    showVerificationCodeComponent?: () => void;
    forInvitation?: boolean;
    token?: string;
    email?: string;
    showPasswordValidationMessage?: boolean;
    showTermOfServiceAndPrivacyPolicy?: boolean;
    showLoginLink?: boolean;
    landingPage?: string;
    isLtdUser?: boolean;
  };

export default withRouter(connector(SignupForm));
